/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Metadata for rollout action execution including debugging information.
 */
export interface RolloutActionMetadata { 
    /**
     * Quartz scheduler job history ID for correlating with job execution logs.
     */
    quartz_job_id?: number;
    /**
     * Distributed tracing trace ID for log correlation.
     */
    trace_id?: string;
    /**
     * Distributed tracing span ID for log correlation.
     */
    span_id?: string;
    /**
     * Exception message if the action failed.
     */
    exception_message?: string;
    /**
     * Root cause of the exception chain.
     */
    exception_root_cause?: string;
}

